import {Payload} from '../../../../../core/service/payload/payload';

export class ReportComponentPreviewPayload implements Payload {
    id: number;
    containerWidth: number;
}
